import axios from 'axios';
import { store } from '../vuex/store';

const quickOrders = axios.create({

    baseURL: process.env.VUE_APP_BASE_URL + '/quickOrderApi',
    // withCredentials: true,
    headers: {

        'Content-Type' : 'application/x-www-form-urlencoded',
        'AuthType'     : 'JWT',
        'ApiKey'       : process.env.VUE_APP_API_KEY
    }
});

quickOrders.interceptors.request.use( req => {

    // console.log( 'before change request: ', req );
    let token = localStorage.getItem( 'token' ) || null;
    if( token ) req.headers.Token = token;
    console.log( 'after change request: ', req );
    // let targetEndpoint = req.url.split( '/' );

    // if( ![ 'checkMenuVersion' ].includes( targetEndpoint[ targetEndpoint.length - 1 ] ) ){

            // not in use, kept for purposes of showing that this is possible..
    // }
    store.state.isLoading = true;

    return req;
});

quickOrders.interceptors.response.use( config => {

    console.log( 'response: ', config );
    console.log( 'response code:: ' + config.data.responseCode + ' ::' );
    store.state.isLoading = false;
    return config;
});

export default quickOrders;